<page-header
        [icon]="['QA', 'LANGUAGE'] | monIcons"
    [header]="'Issues by Page' | translate"
        [subHeader]="subheaderTranslation">
</page-header>

<!-- Warning message when language attribute is disabled -->
<div class="alert alert-warning font-size-1-3 font-weight-500 justify-content-center row" *ngIf="!isLanguageAttributeEnabled" translate>
    Use language attribute is disabled for this domain, please activate it to use this module
</div>

<!-- Main content - only show when language attribute is enabled -->
<div *ngIf="isLanguageAttributeEnabled">
<mon-tabs
        [options]="tabs"
        [(status)]="activeTab"
        (onStatus)="onStatus($event)"
        (onSearch)="onSearch($event)"
        [search]="search"
        [minSearchLength]="1"
        [showSearch]="true"
        [showFiltersBtn]="showFilters"
        [(isFiltersOpen)]="isFiltersOpen">
</mon-tabs>

<div class="card panel-monsido-card">
    <div class="card-body">
        <div class="px-4">
        <table-container [noResultMessage]="'Good job! No language issues were found' | translate"
                         [collection]="pages"
                         (onPageChange)="onPageChange($event)"
                         (onPerPageChange)="onPageSizeChange($event)"
                         [progress]="progress"
                         class="language-match-table-wrapper">
    <table-container-top>
        <div class="outer-b merge-r-16 merge-l-16 merge-t-10" *ngIf="isFiltersOpen">
            <table-filters [(open)]="isFiltersOpen"
                           [ngModel]="filters"
                           name="filters"
                           [filters]="availableFilters"
                           (onChanges)="onFiltersChanges($event)">
            </table-filters>
        </div>
    </table-container-top>
    <table class="table table-hover table-fixed table-with-labels" *ngIf="currentSort">
        <thead>
            <tr>
                <th monTableSort
                    class="col-25"
                    [monSortDirection]="currentSort.direction"
                    monSortBy="title"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onMonTableSort($event)">
                    {{'Title and URL' | translate}}
                </th>
                <th class="col-8 text-right"
                    monTableSort
                    [monSortDirection]="currentSort.direction"
                    monSortBy="language"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onMonTableSort($event)">
                    {{'Declared language' | translate}}
                </th>
                <th class="col-8 text-right"
                    monTableSort
                    [monSortDirection]="currentSort.direction"
                    monSortBy="language"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onMonTableSort($event)">
                    {{'Detected language' | translate}}
                </th>
                <th class="col-6 text-right">
                    {{'Multi-language' | translate}}
                </th>
                <th *ngIf="activeTab !== 'pdf' && activeTab !== 'document'"
                    class="table-header-page-views col-4 text-right"
                    monTableSort
                    [monSortDirection]="currentSort.direction"
                    monSortBy="hits"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onMonTableSort($event)">
                    <span>{{ 'Views' | translate }}</span>
                    <span class="ml-1"
                          [ngClass]="['PRIORITIZED', 'QUESTION_CIRCLE'] | monIcons"
                          aria-hidden="true"
                          ngbTooltip="{{ 'Total page views over the last 30 days' | translate }}"
                          [triggers]="'focus hover'">
                    </span>
                </th>
                <th class="col-sm-8 col-lg-6">&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let page of pages">
                <td>
                    <div class="text-ellipsis">
                        <url-title-page-details
                                *ngIf="page.type === 'html'"
                                target="page-details-section-qa"
                                subTarget="language-match"
                                [page]="page"
                                [title]="page.title"
                                [url]="page.url"
                                [active]="true">
                        </url-title-page-details>

                        <url-title-document-details
                                [document]="page"
                                *ngIf="page.type !== 'html'"
                                [title]="page.title"
                                [url]="page.url"
                                target="page-details-section-qa"
                                [active]="true"
                                subTarget="language-match">
                        </url-title-document-details>
                    </div>
                    <label-table *ngIf="showLabels"
                                 [assignedLabels]="page.labels"
                                 [existingLabels]="labels"
                                 (getLabels)="getLabels()"
                                 (onUpdateLabel)="updateLabels(page)">
                    </label-table>
                </td>
                <td class="text-v-middle text-right">
                    <span *ngIf="page.language_match?.declared_language" class="text-capitalize">
                        {{ page.language_match.declared_language | languageDisplay }}
                    </span>
                    <span class="text-muted" *ngIf="!page.language_match?.declared_language">
                        {{ 'Not declared' | translate }}
                    </span>
                </td>
                <td class="text-v-middle text-right">
                    <div class="d-flex justify-content-end align-items-center" *ngIf="page.language_match?.detected_languages && page.language_match.detected_languages.length > 0">
                        <span class="label label-info text-nowrap mr-1"
                              *ngFor="let language of page.language_match.detected_languages.slice(0, 2); let i = index"
                              style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                              [title]="language | languageDisplay">
                            {{ language | languageDisplay }}
                        </span>
                        <span class="text-muted text-nowrap"
                              *ngIf="page.language_match.detected_languages.length > 2"
                              ngbTooltip="{{ getRemainingLanguagesTooltip(page.language_match.detected_languages) }}"
                              [triggers]="'focus hover'">
                            +{{ page.language_match.detected_languages.length - 2 }} {{ 'more' | translate }}
                        </span>
                    </div>
                    <span class="text-muted" *ngIf="!page.language_match?.detected_languages || page.language_match.detected_languages.length === 0">
                        {{ 'Not detected' | translate }}
                    </span>
                </td>
                <td class="text-v-middle text-center">
                    <i class="fas"
                       [ngClass]="page.language_match?.tag_multi_language ? 'fa-check-circle text-success' : 'fa-times-circle text-muted'"
                       [title]="page.language_match?.tag_multi_language ? ('Yes' | translate) : ('No' | translate)">
                    </i>
                </td>
                <td *ngIf="activeTab !== 'pdf' && activeTab !== 'document'" class="text-v-middle text-right pr-3">
                    <visits [visits]="page.hits"
                            [title]="page.title"
                            [totalVisits]="pages.pageHits">
                    </visits>
                </td>
                <td class="text-v-middle">
                    <div class="d-flex align-items-center justify-content-end flex-wrap flex-md-nowrap">
                        <table-page-details
                                *ngIf="page.type === 'html'"
                                ngbTooltip="{{'Open page details' | translate}}"
                                [triggers]="'focus hover'"
                                target="page-details-section-qa"
                                subTarget="language-match"
                                [page]="page">
                        </table-page-details>
                        <table-document-details
                                *ngIf="page.type !== 'html'"
                                ngbTooltip="{{'Open document details' | translate}}"
                                [triggers]="'focus hover'"
                                target="page-details-section-qa"
                                subTarget="language-match"
                                [document]="page">
                        </table-document-details>
                        <extension-visual-link-button [page]="page" type="language-match" class="ml-1"></extension-visual-link-button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</table-container>
        </div>
    </div>
</div>
</div> <!-- End conditional content -->
